var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomLocalProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50074 4.5077H16.4993C16.8013 4.5077 17.0802 4.66956 17.2301 4.93183L18.8445 7.7571C19.1652 8.31827 18.76 9.01649 18.1137 9.01649H3.8863C3.23998 9.01649 2.83478 8.31827 3.15545 7.7571L4.76989 4.93183C4.91976 4.66956 5.19867 4.5077 5.50074 4.5077ZM5.50074 3.36594C4.78894 3.36594 4.13172 3.74734 3.77857 4.36536L2.16413 7.19063C1.40851 8.51296 2.36331 10.1582 3.8863 10.1582H18.1137C19.6367 10.1582 20.5915 8.51296 19.8359 7.19063L18.2214 4.36536C17.8683 3.74734 17.2111 3.36594 16.4993 3.36594H5.50074Z",
    fill: "#58595B",
    stroke: "#58595B",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50807 10.0582C4.50807 9.74293 4.25248 9.48734 3.93719 9.48734C3.6219 9.48734 3.36631 9.74293 3.36631 10.0582V16.1796C3.36631 17.5352 4.46518 18.634 5.8207 18.634H16.18C17.5356 18.634 18.6344 17.5352 18.6344 16.1796V10.0582C18.6344 9.74293 18.3788 9.48734 18.0636 9.48734C17.7483 9.48734 17.4927 9.74293 17.4927 10.0582V16.1796C17.4927 16.9046 16.905 17.4923 16.18 17.4923H5.8207C5.09575 17.4923 4.50807 16.9046 4.50807 16.1796V10.0582Z",
    fill: "#58595B",
    stroke: "#58595B",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68775 14.7671C9.68775 14.0421 10.2754 13.4544 11.0004 13.4544C11.7253 13.4544 12.313 14.0421 12.313 14.7671V18.0632C12.313 18.3785 12.5686 18.6341 12.8839 18.6341C13.1992 18.6341 13.4548 18.3785 13.4548 18.0632V14.7671C13.4548 13.4115 12.3559 12.3127 11.0004 12.3127C9.64487 12.3127 8.546 13.4115 8.546 14.7671V18.0632C8.546 18.3785 8.80159 18.6341 9.11688 18.6341C9.43216 18.6341 9.68775 18.3785 9.68775 18.0632V14.7671Z",
    fill: "#58595B",
    stroke: "#58595B",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomLocalProduct);
export default __webpack_public_path__ + "static/media/CustomLocalProduct.a8f8b7c0a79c706579f2918dcffa0f6d.svg";
export { ForwardRef as ReactComponent };